import { UcoastEl } from '@/scripts/core/UcoastEl'

export class GenericSection extends UcoastEl {
	static htmlSelector = 'generic-section'
	constructor() {
		super()
	}
}
